/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-10 11:22:43
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';

import apiService from 'src/services/api-service';
import {
  GET_QUICK_START_GUIDES_REQUEST,
  GET_QUICK_START_GUIDES_SUCCESS,
  GET_QUICK_START_GUIDES_FAILURE,
  MARK_DONE_STEP_REQUEST,
  MARK_DONE_STEP_SUCCESS,
  MARK_DONE_STEP_FAILURE,
  GUIDE_SEND_FEEDBACK_REQUEST,
  GUIDE_SEND_FEEDBACK_SUCCESS,
  GUIDE_SEND_FEEDBACK_FAILURE
} from 'stores/flow-type/dashboard/quick-start-guide.type';

/**
 * call to update tenantApp api
 * @return {object} The RSAA object for API middleware
 */
export const getQuickStartGuides = (body, i18n: I18n) => {
  return apiService.sendRequest('admin-v3.quick-start-guide.get-steps', {}, [
    GET_QUICK_START_GUIDES_REQUEST,
    {
      type: GET_QUICK_START_GUIDES_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    },
    {
      type: GET_QUICK_START_GUIDES_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.DashboardV3.Actions.getQuickStartGuide'),
          i18n
        )
    }
  ]);
};

/**
 * call to update tenantApp api
 * @return {object} The RSAA object for API middleware
 */
export const markDoneStep = (name, value, i18n: I18n) => {
  const params = { name };
  return apiService.sendRequest(
    'admin-v3.quick-start-guide.mark-done-step',
    { params, body: value },
    [
      MARK_DONE_STEP_REQUEST,
      {
        type: MARK_DONE_STEP_SUCCESS,
        payload: async (action, state, res) => {
          const data = await getJSON(res);
          return { data };
        }
      },
      {
        type: MARK_DONE_STEP_FAILURE,
        payload: async (action, state, res) =>
          await processRes(
            res,
            'error',
            i18n.translate('AdminHTML.DashboardV3.Actions.markDoneStep'),
            i18n
          )
      }
    ]
  );
};

/**
 * call to send feed back after done guide
 * @return {object} The RSAA object for API middleware
 */
export const sendFeedback = (data, feature, i18n: I18n) => {
  return apiService.sendRequest('admin-v3.quick-start-guide.send-feedback', { body: data }, [
    {
      type: GUIDE_SEND_FEEDBACK_REQUEST,
      payload: () => {
        return { feature };
      }
    },
    {
      type: GUIDE_SEND_FEEDBACK_SUCCESS,
      payload: async (action, state, res) => {
        const data = await processRes(
          res,
          'info',
          i18n.translate('AdminHTML.DashboardV3.Actions.sendFeedbackGuideSuccess'),
          i18n
        );
        return { data, feature };
      }
    },
    {
      type: GUIDE_SEND_FEEDBACK_FAILURE,
      payload: async (action, state, res) => {
        const result = await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.DashboardV3.Actions.sendFeedbackGuide'),
          i18n
        );
        return { ...result, feature };
      }
    }
  ]);
};
